<template>
  <div>
    <el-bread-crumb :bread-cumb="breadCrumb"/>
    <el-row>
      <el-col :span="12">
        <el-form :model="form" ref="form" label-width="70px" v-loading="loading">
          <el-form-item label="活动名称">
            <div>{{ form.activity_name }}</div>
          </el-form-item>
          <el-form-item label="活动店铺">
            <div>{{ form.shop_name }}</div>
          </el-form-item>
          <el-form-item label="活动简介">
            <div>{{ form.brief }}</div>
          </el-form-item>
          <el-form-item label="活动时间">
            <div>{{ form.begin_time }} 至 {{ form.end_time }}</div>
          </el-form-item>
          <el-form-item label="活动介绍">
            <!--            style="border: 1px solid #e2e2e2;border-radius: 6px;"-->
            <div class="ql-editor" style="padding-left: 0;">
              <div v-html="form.intro"></div>
            </div>
          </el-form-item>
          <el-form-item label="活动人数">
            <div>{{ form.join_num }} / {{ form.number }}</div>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <preview :data="form.intro"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import ElBreadCrumb from '../../components/BreadCumb.vue'
import Preview from "./components/preview.vue";

export default {
  name: "activityDetail",
  components: {
    Preview,
    ElBreadCrumb
  },
  data() {
    return {
      form: {},
      loading: false,
      breadCrumb: [],
      shops: []
    }
  },
  created() {
    this.breadCrumb = [
      {'name': '活动列表', 'path': `/activity/list/${this.$route.params.ruleId}`},
      {'name': '查看活动', 'path': ''}]
    try {
      this.shops = JSON.parse(localStorage.getItem('shops'));
    } catch (e) {
      this.shops = [];
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$api.get_glue(this.$apiUrl.getActivityDetail, {id: this.$route.query.id}, res => {
        this.loading = false;
        console.log(res);
        const data = res.data || {};
        this.form = {...data, time: data.begin_time && data.end_time ? [data.begin_time, data.end_time] : []};
        this.form.shop_name = this.shops.length && this.form.shop_id ? this.shops.find(i => i.id == this.form.shop_id).name : '';
      }, res => {
        this.loading = false;
      })
    },
    open(row) {
      this.form = row;
    },
    hide() {
      setTimeout(() => {
        this.form = {};
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// activityDetail.vue?f2f2c62a